export const navbarLinks = [
  { label: '首页', href: '/' },
  { label: '故事', href: '/category/story' },
  { label: '角色', href: '/category/characters' },
  { label: '玩法攻略', href: '/category/guide' },
  { label: '剧情', href: '/category/plot' },
  { label: '关于我们', href: '/about' },
];

export const heroData = {
  title: '樱境物语',
  subtitle: '以樱为名，赴一场唯美奇旅',
  description: '沉浸式叙事体验，走进樱花纷飞的幻想世界，感受物语之美，开启专属你的樱花奇旅。',
  ctaPrimary: '开启旅程',
  ctaSecondary: '了解更多',
};

export const characters = [
  {
    id: 'sakura-hime',
    name: '樱姬',
    title: '樱花精灵',
    description: '樱境的守护者，拥有操控樱花之力。温柔而坚定，守护着这片美丽的土地。她的笑容如春日暖阳，温暖每一个到访樱境的旅人。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20cherry%20blossom%20fairy%20princess%20with%20long%20pink%20hair%20wearing%20traditional%20Japanese%20kimono%20with%20sakura%20petals%20floating%20around%20her%2C%20soft%20warm%20lighting%2C%20ethereal%20atmosphere%2C%20clean%20pastel%20background%2C%20illustration%20style%20with%20delicate%20linework%2C%20gentle%20expression%2C%20magical%20glowing%20cherry%20blossoms&width=600&height=800&seq=sakura-character-01&orientation=portrait',
  },
  {
    id: 'kenshin',
    name: '剑心',
    title: '流浪剑客',
    description: '背负着神秘过去的剑客，沉默寡言但内心炽热。他的剑术出神入化，只为守护心中重要之人。在樱花树下立下不朽的誓言。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20wandering%20samurai%20with%20dark%20hair%20holding%20a%20katana%20under%20cherry%20blossom%20tree%2C%20traditional%20Japanese%20hakama%20clothing%2C%20serene%20expression%2C%20cherry%20petals%20falling%2C%20soft%20pastel%20background%20with%20warm%20golden%20light%2C%20illustration%20style%20clean%20linework&width=600&height=800&seq=sakura-character-02&orientation=portrait',
  },
  {
    id: 'yuki',
    name: '雪',
    title: '冰雪巫女',
    description: '来自北境的神秘巫女，拥有冻结一切的力量。外表冰冷，内心却藏着不为人知的温柔。她的命运与樱境的存亡紧密相连。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20mysterious%20shrine%20maiden%20with%20silver%20white%20hair%20wearing%20traditional%20miko%20outfit%2C%20ice%20crystals%20and%20cherry%20blossoms%20surrounding%20her%2C%20cool%20elegant%20expression%2C%20soft%20pastel%20background%2C%20illustration%20with%20delicate%20details&width=600&height=800&seq=sakura-character-03&orientation=portrait',
  },
  {
    id: 'ren',
    name: '莲',
    title: '花之乐师',
    description: '以音乐治愈人心的少年乐师，手中的竹笛能唤起樱花绽放。纯真乐观，是团队中最温暖的存在，用旋律连接每个人的心。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20male%20musician%20playing%20bamboo%20flute%20with%20cherry%20blossoms%20dancing%20around%2C%20gentle%20smile%2C%20traditional%20Japanese%20casual%20clothing%2C%20warm%20spring%20atmosphere%2C%20soft%20pastel%20colors%2C%20illustration%20clean%20art%20style&width=600&height=800&seq=sakura-character-04&orientation=portrait',
  },
];

export const features = [
  {
    icon: 'ri-book-open-line',
    title: '沉浸式叙事',
    description: '超过20万字的原创剧本，多线叙事交织，每一个选择都将影响故事的走向与结局。',
  },
  {
    icon: 'ri-palette-line',
    title: '唯美视觉',
    description: '手绘风格的精美插画，每一帧都如樱花般绚烂。动态光影系统营造极致氛围感。',
  },
  {
    icon: 'ri-music-line',
    title: '原创音乐',
    description: '由知名作曲家操刀，融合和风与现代元素的原声音乐，带你沉浸于樱境的每个角落。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '丰富角色',
    description: '超过30位性格鲜明的角色，每位都有专属故事线与羁绊系统，与角色建立深厚情感连接。',
  },
  {
    icon: 'ri-gamepad-line',
    title: '多元玩法',
    description: '探索、解谜、养成、战斗，丰富的玩法系统让樱境之旅充满惊喜与挑战。',
  },
  {
    icon: 'ri-global-line',
    title: '多平台支持',
    description: '支持iOS、Android及PC多平台，随时随地开启你的樱花奇旅。',
  },
];

export const latestArticles = [
  {
    id: 'new-version-2-0',
    slug: 'new-version-2-0',
    title: '「樱境物语」2.0版本「花影篇」正式上线',
    excerpt: '全新剧情章节、两位新角色加入，樱境世界迎来重大更新。探索花影背后的秘密，揭开樱境隐藏千年的真相。',
    category: '故事',
    categorySlug: 'story',
    date: '2026-08-10',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20cherry%20blossom%20landscape%20with%20ancient%20Japanese%20temple%20in%20the%20distance%2C%20magical%20cherry%20petals%20floating%2C%20warm%20golden%20sunset%20lighting%2C%20mystical%20atmosphere%2C%20illustration%20style%20clean%20composition&width=800&height=450&seq=sakura-article-01&orientation=landscape',
  },
  {
    id: 'character-guide-sakura-hime',
    slug: 'character-guide-sakura-hime',
    title: '角色深度解析：樱姬的培养路线与剧情分支全攻略',
    excerpt: '全方位解析核心角色「樱姬」的养成策略、技能搭配以及隐藏剧情分支，助你解锁全部故事线。',
    category: '玩法攻略',
    categorySlug: 'guide',
    date: '2026-08-05',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20closeup%20of%20pink%20haired%20goddess%20character%20surrounded%20by%20magical%20cherry%20blossoms%2C%20detailed%20character%20art%2C%20soft%20glowing%20light%2C%20ethereal%20beauty%2C%20illustration%20with%20intricate%20details&width=800&height=450&seq=sakura-article-02&orientation=landscape',
  },
  {
    id: 'plot-analysis-chapter-5',
    slug: 'plot-analysis-chapter-5',
    title: '剧情深度剖析：第五章「樱落之时」隐藏伏笔全解读',
    excerpt: '逐帧分析第五章中的隐藏细节与伏笔，揭示编剧埋下的惊天秘密。这些细节你注意到了吗？',
    category: '剧情',
    categorySlug: 'plot',
    date: '2026-07-28',
    readTime: '15分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20dramatic%20scene%20of%20cherry%20blossoms%20falling%20in%20twilight%2C%20silhouettes%20of%20two%20figures%20standing%20under%20ancient%20cherry%20tree%2C%20emotional%20atmosphere%2C%20deep%20warm%20colors%2C%20illustration%20cinematic%20composition&width=800&height=450&seq=sakura-article-03&orientation=landscape',
  },
];

export const testimonials = [
  {
    name: '樱花下的旅人',
    avatar: '',
    rating: 5,
    content: '在樱境物语中找到了久违的感动。每一个故事都精心雕琢，每一段音乐都直击心灵。这是我玩过最美的叙事游戏。',
    date: '2026-07-15',
  },
  {
    name: '物语迷',
    avatar: '',
    rating: 5,
    content: '画风太美了！角色塑造非常有深度，樱姬的故事让我哭了好几次。强烈推荐给喜欢日式叙事的玩家。',
    date: '2026-06-28',
  },
  {
    name: 'RPG爱好者',
    avatar: '',
    rating: 4,
    content: '玩法系统做得很用心，不是单纯的视觉小说，战斗和解谜元素让游戏体验更加丰富。期待后续更新！',
    date: '2026-06-10',
  },
];

export const faqData = [
  {
    question: '「樱境物语」是一款什么类型的游戏？',
    answer: '樱境物语是一款以樱花为主题的沉浸式叙事体验游戏，融合了视觉小说、角色扮演、探索解谜等多种玩法元素。游戏以精美的日式手绘画风和原创音乐为载体，讲述了一个关于爱、羁绊与成长的故事。',
  },
  {
    question: '游戏支持哪些平台？',
    answer: '目前樱境物语已支持iOS、Android移动端以及Windows PC平台。我们正在积极开发macOS版本，敬请期待。所有平台账号数据互通，随时随地畅游樱境。',
  },
  {
    question: '游戏是否需要付费？',
    answer: '樱境物语采用免费下载+章节内购的模式。前三个章节可免费体验完整内容，后续章节可选择单独购买或购买季票解锁全部内容。',
  },
  {
    question: '如何获取最新资讯和活动信息？',
    answer: '你可以关注我们的官方网站、官方微博「樱境物语」、微信公众号「樱境物语Official」获取最新资讯。重大更新和活动也会通过游戏内公告推送。',
  },
  {
    question: '游戏中的选择真的会影响结局吗？',
    answer: '是的！樱境物语采用多分支叙事系统，游戏中有超过50个关键选择节点，你的每一个决定都将影响角色关系、剧情走向以及最终的结局。目前游戏共有7种不同的结局。',
  },
];

export const timelineData = [
  { year: '2024.06', title: '项目立项', description: '樱境物语正式立项，核心创作团队集结完毕' },
  { year: '2025.03', title: '首次内测', description: '面向核心玩家群体进行首次封闭测试，收集反馈' },
  { year: '2025.09', title: '公开测试', description: '开放公测，首周注册用户突破50万' },
  { year: '2026.01', title: '正式上线', description: '樱境物语1.0版本全平台正式发布' },
  { year: '2026.08', title: '花影篇更新', description: '2.0版本「花影篇」上线，全新剧情与新角色' },
];

export const contactInfo = {
  email: 'contact@6shouyou.cn',
  weibo: '@樱境物语',
  wechat: '樱境物语Official',
  address: '上海市浦东新区樱花路888号樱境大厦',
};